const TONE = {
  ACTIVE: 'badge-ok',
  VERIFIED: 'badge-ok',
  PENDING: 'badge-warn',
  UNDER_REVIEW: 'badge-warn',
  ASSIGNED_TO_SALES: 'badge-warn',
  // Activation codes: Allocated is in flight, Used is the settled end state.
  ALLOCATED: 'badge-warn',
  USED: 'badge-ok',
  RENEWAL_DUE: 'badge-warn',
  SUSPENDED: 'badge-danger',
  REJECTED: 'badge-danger',
  EXPIRED: 'badge-danger',
};

export function labelOf(value) {
  return String(value ?? '')
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/^./, (character) => character.toUpperCase());
}

export default function StatusBadge({ status }) {
  if (!status) return null;
  return <span className={`badge ${TONE[status] ?? ''}`}>{labelOf(status)}</span>;
}
